import { render, staticRenderFns } from "./DashboardCategory.vue?vue&type=template&id=2f32574a&"
import script from "./DashboardCategory.vue?vue&type=script&lang=js&"
export * from "./DashboardCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports